import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { LibsModule } from 'src/app/libs/libs.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { KeuanganRoutingModule } from './keuangan-routing.module';

import { KeuanganSaldoComponent } from './saldo/keuangan-saldo.component';
import { KeuanganKomisiComponent } from './komisi/keuangan-komisi.component';
import { TableRiwayatPenarikanSaldoComponent } from './components/table-riwayat-penarikan-saldo/table-riwayat-penarikan-saldo.component';
import { DetailRiwayatSaldoComponent } from './components/detail-riwayat-penarikan-saldo/detail-riwayat-penarikan-saldo.component';
import { DetailSaldoComponent } from './components/detail-saldo/detail-saldo.component';
import { DetailKomisiComponent } from './components/detail-komisi/detail-komisi.component';

@NgModule({
  declarations: [
    KeuanganSaldoComponent,
    KeuanganKomisiComponent,
    TableRiwayatPenarikanSaldoComponent,
    DetailRiwayatSaldoComponent,
    DetailSaldoComponent,
    DetailKomisiComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbDropdownModule,
    AntDModule,
    SharedModule,
    LibsModule,
    NgxDaterangepickerMd,
    KeuanganRoutingModule
  ],
  exports: [
    KeuanganSaldoComponent,
    KeuanganKomisiComponent,
    TableRiwayatPenarikanSaldoComponent,
    DetailRiwayatSaldoComponent,
    DetailSaldoComponent,
    DetailKomisiComponent
  ]
})
export class KeuanganModule { }
